import React from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

export interface RowAvailabilityIconProps {
	status: string;
}

export function RowAvailabilityIcon({ status }: RowAvailabilityIconProps) {
	if (status === 'available') {
		return <FaCheckCircle className='w-4 h-4 text-green-600' />;
	}
	return <FaTimesCircle className='w-4 h-4 text-red-600' />;
}
